import React from 'react'
import { TranslationProvider } from '../../shared/TranslationProvider'
import BenefitsProvider, { useBenefits } from '../BenefitsProvider'
import translations from '../locales.json'
import SelectCoachServicesPage from './SelectCoachServicesPage'
import PremiumCoachServicesPage from './PremiumCoachServices'

const Page = () => {
  const { current_user } = useBenefits()

  if (current_user.select) return <SelectCoachServicesPage />
  return <PremiumCoachServicesPage />
}

const Index = ({ ...props }) => {
  const { current_user } = props
  return (
    <TranslationProvider
      locale={current_user.locale}
      translations={translations}
      scope="javascript.components.coach_services"
    >
      <BenefitsProvider {...props}>
        <Page />
      </BenefitsProvider>
    </TranslationProvider>
  )
}

export default Index
